module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cQyoe"))).then(() => module.bundle.root('37nVf'));